import React from 'react';

export const CloseIcon = props => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    {...props}
  >
    <path d='M8 6.5l4.646-4.646a.5.5 0 0 1 .708 0l.792.792a.5.5 0 0 1 0 .708L9.5 8l4.646 4.646a.5.5 0 0 1 0 .707l-.792.793a.5.5 0 0 1-.708 0L8 9.5l-4.646 4.646a.5.5 0 0 1-.708 0l-.792-.793a.5.5 0 0 1 0-.707L6.5 8 1.854 3.354a.5.5 0 0 1 0-.708l.792-.792a.5.5 0 0 1 .708 0L8 6.5z' />
  </svg>
);
